import type { ActionHandler } from '../types'

export const handleTreatWound: ActionHandler<'TREAT_WOUND'> = async (ctx, payload) => {
  const { data: old } = await ctx.supabase
    .from('character_injuries')
    .select('is_treated, healing_rate, treatment_notes')
    .eq('id', payload.injury_id)
    .single()

  if (!old) throw new Error('Injury not found')

  const updates = {
    is_treated: true,
    healing_rate: payload.healing_rate,
    treatment_notes: payload.treatment_notes ?? null,
  }

  const { error } = await ctx.supabase
    .from('character_injuries')
    .update(updates)
    .eq('id', payload.injury_id)

  if (error) throw error

  const effects = Object.entries(updates)
    .filter(([key]) => (old as Record<string, unknown>)[key] !== (updates as Record<string, unknown>)[key])
    .map(([key, val]) => ({
      character_id: ctx.characterId,
      target_table: 'character_injuries',
      target_row_id: payload.injury_id,
      target_field: key,
      operation: 'UPDATE' as const,
      old_value: (old as Record<string, unknown>)[key],
      new_value: val,
    }))

  return {
    effects,
    label: `Treat wound: HR ${payload.healing_rate}`,
  }
}
